
import catalogService from '@/services/catalog'

export default () =>
    catalogService.fetch('invoice_status', { path: 'taxreceipt' })



// WEBPACK FOOTER //
// ./src/services/taxReceipt/fetchInvoiceStatus.js